import React from "react";
import PropTypes from "prop-types";
import StarRating from "wonderbly-components/lib/StarRating";
import TrustpilotStars from "../TrustpilotStars/TrustpilotStars.js";

const StarsTheme = (props) => {
  const stars = Math.round(props.stars || 5).toString();

  if (props.theme === "trustpilot") {
    return <TrustpilotStars stars={stars} />;
  }

  return <StarRating stars={stars} />;
};

StarsTheme.propTypes = {
  theme: PropTypes.string,
  stars: PropTypes.number,
  productRating: PropTypes.number,
};

StarsTheme.defaultProps = {
  stars: 5,
};

export default StarsTheme;
